// extracted by mini-css-extract-plugin
export default {"marks":"Marks_marks__dyjHV","mark":"Marks_mark__DdmAc","isSystemMark":"Marks_isSystemMark__Fn2kg","isInterestsMark":"Marks_isInterestsMark__VGYKX"};